export const SERVICE_ACCOUNTS = {
  OPTION: 'Cuenta de servicio',
  MARK_TITLE: 'Marcar como cuenta de servicio',
  MARK_DESCRIPTION: (name: string) =>
    `¿Marcar a ${name} como cuenta de servicio? Saldrá de la lista de empleados y no podrá iniciar sesión. Se borrarán sus resultados de phishing, firmas de políticas y asignaciones.`,
  MARK_CONFIRM: 'Marcar como cuenta de servicio',
  MARKED: 'Marcado como cuenta de servicio',
  TWO_FACTOR: '2FA',
  STATUS: 'Estado',
  MARKED_ON: 'Marcada el',
  RESTORED: 'Devuelta a los empleados',
}
